import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Typography, Chip } from '@mui/material'
import { useDispatch } from 'react-redux'
import styles from './vendorCardStyle.module.scss'
import ButtonCustom from '../button/ButtonCustom'
import { openModal, setModalData } from '../../../features/commonSlice'

const VendorCardList = ({ data, type }) => {
	const dispatch = useDispatch()
	const { customBusinessType, businessTypes } = data

	const { visibleTypes, hiddenCount } = useMemo(() => {
		const normalizedBusinessTypes = Array.isArray(businessTypes)
			? businessTypes.map((t) => String(t).trim()).filter(Boolean)
			: []
		const normalizedCustomType = String(customBusinessType || '').trim()
		const mergedTypes = normalizedCustomType
			? [...normalizedBusinessTypes, normalizedCustomType]
			: normalizedBusinessTypes
		const fallbackTypes = type ? [String(type).trim()].filter(Boolean) : []
		const typeList = mergedTypes.length ? mergedTypes : fallbackTypes
		return {
			visibleTypes: typeList.slice(0, 1),
			hiddenCount: Math.max(typeList.length - 1, 0),
		}
	}, [businessTypes, customBusinessType, type])

	const handleFavoriteClick = (e) => {
		e.preventDefault()
		e.stopPropagation()
		dispatch(openModal('addFavoriteVendorModal'))
		dispatch(setModalData({ vendorId: data._id }))
	}
	return (
		<Link className={styles.vendorCardList} to={`/profile/${data._id}`}>
			<div className={styles.card}>
				<div className={styles.cardImg}>
					<img
						src={
							data.businessProfilePic ||
							'/images/ontimebride_iconset_blue_vendor_default.png'
						}
						alt="business_profile"
					/>
					{data.topVendor && (
						<span className={styles.topLabel}>
							<img
								src="/images/vendor-feat-label.svg"
								alt="vendor-feat-label.svg"
							/>
							Top Vendor
						</span>
					)}
				</div>
				<div className={styles.cardDetails}>
					<div
						style={{
							display: 'flex',
							alignItems: 'start',
							gap: '12px',
						}}
					>
						<div className={styles.nameAndReview}>
							<div className={styles.review}>
								<Typography variant="h4">
									{visibleTypes.map((each) => (
										<Chip
											key={each}
											label={each}
											size="small"
											variant="outlined"
											className={styles.typeChip}
											sx={{
												border: "none",
												'& .MuiChip-label': {
													fontSize: '12px',
													lineHeight: '14px',
													padding: "1px"
												},
											}}
										/>
									))}
									{hiddenCount > 0 && (
										<span className={styles.moreTypesChip}>
											{' '}
											+{hiddenCount} more
										</span>
									)}
								</Typography>
								<ul className={styles.rating}>
									{[1, 2, 3, 4, 5].map((star) => (
										<li key={star}>
											<img
												src={
													star <=
													Math.round(
														data.avgRating || 0
													)
														? '/images/star.svg'
														: '/images/star-without-fill.svg'
												}
												alt="star.svg"
											/>
										</li>
									))}
								</ul>
							</div>
							<Typography
								variant="h3"
								className={styles.vendorName}
							>
								{data.businessName}
							</Typography>
						</div>
						<ButtonCustom
							variant="outlined"
							size="sm"
							style={{
								padding: '8px',
							}}
							onClick={handleFavoriteClick}
						>
							<img src="/images/heart.svg" alt="heart" />
						</ButtonCustom>
					</div>
					<div className={styles.location}>
						<img src="/images/location.svg" alt="location" />
						<span>{data.businessAddress}</span>
					</div>
				</div>
			</div>
		</Link>
	)
}

export default VendorCardList
